import { render, staticRenderFns } from "./TrendWidget.vue?vue&type=template&id=2e30c303&scoped=true&"
import script from "./TrendWidget.vue?vue&type=script&lang=js&"
export * from "./TrendWidget.vue?vue&type=script&lang=js&"
import style0 from "./TrendWidget.vue?vue&type=style&index=0&id=2e30c303&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e30c303",
  null
  
)

export default component.exports